import { render, staticRenderFns } from "./PassportReportModal.vue?vue&type=template&id=4efb10d2&"
import script from "./PassportReportModal.vue?vue&type=script&lang=js&"
export * from "./PassportReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports